import { Component, Input } from "@angular/core";
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from "@angular/forms";
import { PopoverController } from "@ionic/angular";
import { TimePickerPopoverComponent } from "./time-picker-popover/time-picker-popover.component";

@Component({
    selector: "time-picker",
    templateUrl: "time-picker.html",
    styleUrls: ["time-picker.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: GyzmoTimePickerComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: GyzmoTimePickerComponent,
        },
    ],
})
export class GyzmoTimePickerComponent implements ControlValueAccessor, Validator {
    @Input() label: string;
    @Input() minTime: string;
    @Input() disabled: boolean = false;
    @Input() showIcon: boolean = false;
    @Input() showDebugInfo: boolean = false;
    @Input() labelPlacement: "fixed" | "floating" | "stacked" = "stacked";

    time: string = "";
    touched = false;

    constructor(private popoverController: PopoverController) {
    }

    onChange = (time) => {
    };

    onTouched = () => {
    };

    registerOnChange(onChange: any): void {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any): void {
        this.onTouched = onTouched;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(value: any): void {
        this.time = value;
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        const time = control.value;
        if (this.minTime && time < this.minTime) {
            return {
                min: {
                    time,
                },
            };
        }
        return null;
    }

    async openTimePicker() {
        if (this.disabled) {
            return;
        }

        const myTimePickerModal = await this.popoverController.create({
            component: TimePickerPopoverComponent,
            cssClass: "li-ionic-timepicker",
            componentProps: {
                "selectedTime": this.time,
            },
            animated: false,
        });
        void myTimePickerModal.onDidDismiss()
            .then((data) => {
                this.markAsTouched();

                if (data.data && data.data.time) {
                    this.time = data.data.time;
                    this.onChange(data.data.time);
                }
            });

        await myTimePickerModal.present();
    }

    public getDisplayedHour() {
        return this.time;
    }
}
